export const prerender = true;
export const ssr = true;

import type { LayoutLoad } from './$types';
import { browser } from '$app/environment';
import { loadLocale } from 'wuchale/load-utils';
// so that the loaders are registered, only here, not required in nested ones (below)
import '../locales/main.loader.svelte.js';
import '../locales/js.loader.js';
import { selectGetLocaleCookieFn, selectSetLocaleCookieFn } from '$lib/utils.svelte';

export const load: LayoutLoad = async (event) => {
	const paramsLocale = event.params.locale;
	const cookieLocale = await selectGetLocaleCookieFn(event.route.id)();
	const locale = (() => {
		if (event.route.id?.includes('[[locale=locale]]')) {
			// If the route is localized by the url slug,
			// don't use the cookie for localization
			const tempLocale = paramsLocale ?? 'en';
			// and then set the cookie to immediatly persist any changes
			selectSetLocaleCookieFn(event.route.id)(tempLocale);
			return tempLocale;
		}
		return paramsLocale ?? cookieLocale ?? 'en';
	})();
	if (browser) {
		await loadLocale(locale, true);
	}
	return { locale };
};
